module.exports = __webpack_public_path__ + "img/responsive hospitium-07.b0643b43.jpg";